import { ReviewCreationDTO, ReviewDTO } from "../domain/models/dto/ReviewDTO";
import { CollectionResponse } from "../types/ApiResults";
import { ApiServiceImpl, createAsyncThunkFactory } from "./ApiServiceImpl";

export class ReviewServiceImpl extends ApiServiceImpl {
    private constructor() {
        super();
    }

    static createReviewThunk = createAsyncThunkFactory<
        ReviewDTO,
        ReviewCreationDTO
    >("ReviewServiceImpl.createReview", async (args) => {
        return this.post("/api/v1/review", args);
    });

    static getUserReviewsThunk = createAsyncThunkFactory<
        CollectionResponse<ReviewDTO>,
        { page: number; limit: number; offset: number; userId: string }
    >("ReviewServiceImpl.getUserReviews", async (args) => {
        return this.getCollection("/api/v1/review", args);
    });
}
